import DashboardFlaggedTransacionsSummaryItem from './DashboardFlaggedTransacionsSummaryItem';

import { UIAskRequestsTitles, UIFlaggedTransactionStatus } from 'types/askcustomer';
import { useGetQueueRequestsCountQuery } from 'hooks/queue';
import { useLocationsStore } from 'hooks/useLocationsStore';

export default function DashboardFlaggedTransacionsSummary() {
  const currentLocationId = useLocationsStore(state => state.currentLocationId);
  const { data, isSuccess } = useGetQueueRequestsCountQuery({ locationId: currentLocationId });

  // Map new QueueViewCountsResponse to old tab structure:
  // - "Customer" (Open) → Me + My Team (items accountant needs to work on)
  // - "Bookkeeper" (In Progress) → Client (items waiting on client)
  // - "Recently Resolved" (Closed) → Completed
  const openCount = (data?.Me ?? 0) + (data?.['My Team'] ?? 0);
  const inProgressCount = data?.Client ?? 0;
  const closedCount = data?.Completed ?? 0;

  return isSuccess ? (
    <div className="dashboard-flagged-transactions-container__summary">
      <DashboardFlaggedTransacionsSummaryItem
        indicator={openCount}
        title={UIAskRequestsTitles.CUSTOMER}
        activeTab={'Open'}
      />
      <DashboardFlaggedTransacionsSummaryItem
        indicator={inProgressCount}
        title={UIAskRequestsTitles.BOOKKEEPER}
        addBorder
        activeTab={'In Progress'}
      />
      <DashboardFlaggedTransacionsSummaryItem
        indicator={closedCount}
        title={UIAskRequestsTitles.RECENTLY_RESOLVED}
        activeTab={'Closed'}
      />
    </div>
  ) : null;
}
